import api from "./api";

export const addAddress = async (payload, orderFormId, email) => {
  const { data } = await api.post(
    `/checkout/cart/${orderFormId}/shippingdata`,
    payload,
    email ? { headers: { "X-Cobasi-Email": email } } : undefined
  );
  return data;
};

export const getShippingSimulate = async (payload, orderFormId, email) => {
  const { data } = await api.post(
    `/checkout/cart/${orderFormId}/shippingdata/simulate`,
    payload,
    email ? { headers: { "X-Cobasi-Email": email } } : undefined
  );

  return data;
};

export const getUserAddresses = async (email) => {
  const { data } = await api.get(
    `users/addresses`,
    email ? { headers: { "X-Cobasi-Email": email } } : undefined
  );
  return data;
};

export const deleteUserAddress = async (addressId, email) => {
  try {
    // Tratamento para pegar o id correto do endereço
    const userAddresses = await getUserAddresses(email);
    const address = userAddresses.find(
      (item) => item.addressName === addressId
    );

    await api.delete(
      `users/address/${address.id}`,
      email ? { headers: { "X-Cobasi-Email": email } } : undefined
    );

    return address;
  } catch (error) {
    throw new Error(error);
  }
};
